import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendUp,
  faArrowTrendDown,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import {
  StatCard,
  StatCardHeader,
  StatCardTitle,
  StatCardIcon,
  StatCardValue,
  StatCardSubtitle,
  TrendBadge,
  ProgressContainer,
  ProgressLabel,
  StyledProgress,
  ValueSkeleton,
  ProgressSkeleton,
  ProgressSkeletonSmall,
} from './Styles';
import { COLOR_MAP } from './Constant';
import type { StatCardProps } from './types';

const StatCardComponent: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  color,
  onClick,
  isSelected,
  trend,
  subtitle,
  progress = 0,
  loading = false,
}) => {
  const accentColor = COLOR_MAP[color] || color;
  const iconBg = `${accentColor}20`;
  const trendColor =
    trend !== undefined
      ? trend > 0
        ? "#52c41a"
        : trend < 0
        ? "#ff4d4f"
        : "#8c8c8c"
      : "#8c8c8c";

  const trendIcon =
    trend !== undefined
      ? trend > 0
        ? faArrowTrendUp
        : trend < 0
        ? faArrowTrendDown
        : faMinus
      : null;

  return (
    <StatCard
      onClick={onClick}
      isSelected={isSelected}
      accentColor={accentColor}
    >
      <StatCardHeader>
        <StatCardTitle>{title}</StatCardTitle>
        <StatCardIcon bg={iconBg} color={accentColor}>
          <FontAwesomeIcon icon={icon} />
        </StatCardIcon>
      </StatCardHeader>

      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {loading ? (
          <ValueSkeleton active />
        ) : (
          <StatCardValue>{value}</StatCardValue>
        )}

        {subtitle && <StatCardSubtitle>{subtitle}</StatCardSubtitle>}

        {trend !== undefined && !loading && (
          <TrendBadge color={trendColor}>
            <FontAwesomeIcon icon={trendIcon || faMinus} />
            <span>
              {trend > 0 ? "+" : ""}
              {trend}% from last week
            </span>
          </TrendBadge>
        )}
      </div>

      <ProgressContainer>
        <ProgressLabel>
          <span>Progress</span>
          {loading ? (
            <ProgressSkeletonSmall active />
          ) : (
            <span>{progress.toFixed(0)}%</span>
          )}
        </ProgressLabel>
        {loading ? (
          <ProgressSkeleton active />
        ) : (
          <StyledProgress
            percent={progress}
            strokeColor={accentColor}
            showInfo={false}
            size="small"
          />
        )}
      </ProgressContainer>
    </StatCard>
  );
};

export default StatCardComponent;